
import React from 'react';
import { Translation } from '../types';
import { Calculator } from '../components/Calculator';

interface Props {
  t: Translation;
}

export const Investment: React.FC<Props> = ({ t }) => {
  return (
    <div className="pt-24">
      <section className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h1 className="text-5xl lg:text-7xl font-light uppercase tracking-tight">Business as an Art</h1>
          <p className="text-xl text-stone-600">The Stealth house isn't just a home; it's a financial instrument designed to maximize occupancy and daily rates in the growing glamping market.</p>
        </div>
      </section>

      <Calculator t={t} />

      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-3 gap-12">
          <div className="p-8 bg-stone-50 rounded-3xl space-y-6">
            <h3 className="text-2xl font-bold uppercase tracking-tight">Glamping Owners</h3>
            <p className="text-stone-500">Upgrade your site with premium units that justify 2x daily rates compared to standard tents or small pods.</p>
          </div>
          <div className="p-8 bg-stone-50 rounded-3xl space-y-6">
            <h3 className="text-2xl font-bold uppercase tracking-tight">Land Investors</h3>
            <p className="text-stone-500">Have land but no time? We offer turnkey solutions including infrastructure setup and management partnerships.</p>
          </div>
          <div className="p-8 bg-stone-50 rounded-3xl space-y-6">
            <h3 className="text-2xl font-bold uppercase tracking-tight">Expansion Strategy</h3>
            <p className="text-stone-500">Modular design allows you to scale from 1 to 10 units in months, not years. All-season utility ensures 365-day cashflow.</p>
          </div>
        </div>
      </section>
    </div>
  );
};
